import React from 'react';

import styles from './questionBox.module.scss';

export const QuestionBox: React.ComponentType = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};
